import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { AbstractControl, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-reset',
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './reset.component.html',
  styleUrl: './reset.component.scss'
})
export class ResetComponent {
  @Input() type!: any;
  dataForm!: UntypedFormGroup;
  submitted: boolean = false;
  @Input() isAuthenticated: boolean = false;

  public authService = inject(AuthService);
  public fb = inject(UntypedFormBuilder);

  ngOnInit(): void {
    this.dataForm = this.fb.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.confirmPasswordValidator('newPassword', 'confirmPassword') });
  }

  ngOnDestroy() {
    this.isAuthenticated = false;
  }

  get formControls() {
    return this.dataForm.controls;
  }

  reset() {
    this.submitted = true;
    if (this.dataForm.valid) {
      if(this.type == "changePassword") {
        this.authService.changePassword(this.dataForm.value);
      } else {
        this.authService.reset(this.dataForm.value);
      }
    }
  }

  confirmPasswordValidator(newPassword: string, confirmPassword: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const newPasswordControl = group.get(newPassword);
      const confirmPasswordControl = group.get(confirmPassword);

      if (newPasswordControl && confirmPasswordControl && newPasswordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl?.setErrors(null);
      }

      return null;
    };
  }
}
